import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'breakAtSpace',
    standalone: false
})
export class BreakAtSpacePipe implements PipeTransform {
  transform(v?: string): string {
    if (! v) return ''
    while (v.includes(' ')) {
      v = v.replace(' ', '<br/>')
    }
    return v
  }
}
